export default __webpack_public_path__ + "static/media/轮播首图6.1c639557.jpg";